/* Native disclosure on mobile; adjacent panel inside the same desktop dialog. */
(() => {
  if (customElements.get('gw-cart-offer-controller')) return;
  class CartOfferController extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.panel = this.querySelector('.gw-cart-offers__panel');
      if (!this.details || !this.panel) return;
      this.drawer = this.closest('theme-drawer');
      this.dialog = this.closest('dialog');
      this.desktop = window.matchMedia('(min-width:990px)');
      if (this.drawer?.dataset.gwOffersOpen === 'true') this.details.open = true;
      this.details.addEventListener('toggle', this.toggle);
      this.panel.addEventListener('click', this.click);
      this.panel.addEventListener('keydown', this.keydown);
      this.details.addEventListener('keydown', this.keydown);
      this.drawer?.addEventListener('theme-drawer:close', this.drawerClosed);
      this.desktop.addEventListener('change', this.breakpoint);
      this.placePanel();
      this.observer = new MutationObserver(() => {
        const details = this.querySelector('details');
        const freshPanel = this.querySelector('.gw-cart-offers__panel');
        if (details !== this.details || (freshPanel && freshPanel !== this.panel)) {
          // Section hydration may reuse this element while replacing its children.
          this.disconnectedCallback();
          this.connectedCallback();
        }
      });
      this.observer.observe(this, {childList:true, subtree:true});
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.details?.removeEventListener('toggle', this.toggle);
      this.panel?.removeEventListener('click', this.click);
      this.panel?.removeEventListener('keydown', this.keydown);
      this.details?.removeEventListener('keydown', this.keydown);
      this.drawer?.removeEventListener('theme-drawer:close', this.drawerClosed);
      this.desktop?.removeEventListener('change', this.breakpoint);
      if (this.panel && !this.contains(this.panel)) this.panel.remove();
    }
    sync = () => {
      this.details.querySelector('summary')?.setAttribute('aria-expanded', String(this.details.open));
      if (this.drawer) this.drawer.dataset.gwOffersOpen = String(this.details.open);
      this.panel.hidden = !this.details.open;
    };
    placePanel = () => {
      if (this.drawer && this.desktop.matches) this.dialog.append(this.panel);
      else this.details.append(this.panel);
      this.sync();
    };
    toggle = () => {
      if (!this.isConnected) return;
      this.sync();
      if (this.details.open && this.drawer && this.desktop.matches) this.panel.querySelector('[data-gw-offers-close]')?.focus();
    };
    close = (restore = true) => {
      this.details.open = false;
      this.sync();
      if (restore) this.details.querySelector('summary')?.focus();
    };
    click = (event) => { if (event.target.closest('[data-gw-offers-close]')) this.close(); };
    keydown = (event) => {
      if (event.key === 'Escape' && this.details.open && !event.isComposing) {
        event.preventDefault(); event.stopPropagation(); this.close();
      }
    };
    drawerClosed = () => this.close(false);
    breakpoint = () => {
      const hadHeaderFocus = this.panel.querySelector('.gw-cart-offers__header')?.contains(document.activeElement);
      this.placePanel();
      if (!this.desktop.matches && hadHeaderFocus) this.details.querySelector('summary')?.focus();
    };
  }
  customElements.define('gw-cart-offer-controller', CartOfferController);
})();
